import React, { useEffect, useState } from 'react'
import { Blurhash } from "react-blurhash";
// import './css/ImageLazy.css'

function ImageLazy({src, hash, aspect}) {

    const [imageLoaded, setImageLoaded] = useState(false);
    const [width, setWidth] = useState(false);

    useEffect(() => {
        const onResize = () => {
            let padding = Math.min(40, 0.08*window.innerWidth);
            let mainwidth = window.innerWidth - 2*padding;
            if(window.innerWidth < 600){
                setWidth(mainwidth);
            }else if(window.innerWidth < 800){
                setWidth((mainwidth - 10)/2);
            }else if(window.innerWidth < 1000){
                setWidth((mainwidth - 10)/3);
            }else{
                setWidth((mainwidth - 10)/4);
            }
        }

        window.addEventListener("resize", onResize);
        onResize();
    
        return () => {
            window.removeEventListener("resize", onResize);
        }
    }, []);

    useEffect(()=>{
        const img = new Image();
        img.onload = () => setImageLoaded(true);
        img.src = src;
    }, [src]);

  return (
    <div className='ImageLazy'>
        {
            !imageLoaded ?
            <Blurhash
                hash={hash}
                width={width}
                height={aspect*width}
                resolutionX={32}
                resolutionY={32}
                punch={1}
            />
            :
            <img className='gallery' onLoad={()=>setImageLoaded(true)} src={src} alt="GalleryItem" />
        }
    </div>
  )
}

export default ImageLazy